"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "@/lib/utils"

function Tabs({
  className,
  dir = "rtl",
  ...props
}) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      dir={dir}
      className={cn("flex flex-col", className)}
      {...props} />
  );
}

function TabsList({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "inline-flex items-center justify-start gap-3",
        className
      )}
      {...props} />
  );
}

function TabsTrigger({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        // استایل‌های پایه
        "inline-flex items-center text-mute justify-center whitespace-nowrap transition-all disabled:pointer-events-none disabled:opacity-50",
        // استایل‌های وضعیت فعال (Active) که درخواست کردید
        "data-[state=active]:glass-box data-[state=active]:text-white",
        className
      )}
      {...props} />
  );
}

function TabsContent({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("outline-none data-[state=inactive]:hidden", className)}
      {...props}
      forceMount
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent }